import get from 'lodash.get';
import isEqual from 'lodash.isequal';
import { createSelector } from 'reselect';
import type { RootState } from '../../../store/types';

export const getFinancingTerms = (state: RootState) => state.financingTerms;

export const getFinancingEntities = createSelector(getFinancingTerms, (financingTerms) => {
  const entities = get(financingTerms, 'entities', {});
  return entities;
});

export const getHasFinancingTerms = createSelector(getFinancingEntities, (entities) => {
  const doesUserHaveFinancing = !isEqual(entities, {});
  return doesUserHaveFinancing;
});

export const getFormattedExpirationDate = createSelector(getFinancingTerms, (termsOverview) => {
  const formattedExpirationDate = get(
    termsOverview,
    'termsOverview.overview.formattedExpirationDate',
    ''
  );
  return formattedExpirationDate;
});

export const getIsLoadingFinancingTerms = createSelector(getFinancingTerms, (financingTerms) => {
  const isLoadingFinancingTerms = get(financingTerms, 'financingTerms.isLoading', true);
  return isLoadingFinancingTerms;
});

export const getFinancingTermsError = createSelector(getFinancingTerms, (financingTerms) => {
  const financingTermsError = get(financingTerms, 'financingTerms.error', {});
  return financingTermsError;
});

export const getHasTermsOverview = createSelector(getFinancingTerms, (termsOverview) => {
  const getTermsOverview = get(termsOverview, 'termsOverview.overview', {});
  const doesUserHaveTermsOverview = !isEqual(getTermsOverview, {});
  return doesUserHaveTermsOverview;
});

export const getTermsOverviewError = createSelector(getFinancingTerms, (termsOverview) => {
  const termsOverviewError = get(termsOverview, 'termsOverview.error', {});
  return termsOverviewError;
});

export const getIsLoadingTermsOverview = createSelector(getFinancingTerms, (termsOverview) => {
  const isLoadingTermsOverview = get(termsOverview, 'termsOverview.isLoading', true);
  return isLoadingTermsOverview;
});

export const getFinancingTermsOverview = createSelector(getFinancingTerms, (termsOverview) => {
  const financingTermsOverview = get(termsOverview, 'termsOverview.overview', null);
  return financingTermsOverview;
});
